export const ultimasNoticias = [

 {
        "imagen": "../assets/imgs/Dia_Jardines_Botanicos.jpg",
        "url": "/pdf/Dia_Jardines_Botanicos.pdf",
        "titulo": "Día Nacional de los Jardines Botánicos",
        "fecha": "Consulta la programación que tendremos próximamente para conmemorar el Día Nacional de los Jardines Botánicos."
    },

    {
        "imagen": "../assets/imgs/PROGRAMA_MADRE_TIERRA.jpg",
        "url": "/pdf/PROGRAMA_MADRE_TIERRA.pdf",
        "titulo" : "Tlalticpactli, semana de la madre tierra.",
        "fecha": "Da clic para consultar las actividades que organizaremos para conmemorar a nuestro hogar en la región huasteca."
    },
    {
        "imagen": "../assets/imgs/AgendaAmbiental2024.jpg",
        "url": "/pdf/AgendaAmbiental2024.pdf",
        "titulo" : "Agenda Ambiental 2024",
        "fecha": "Conoce nuestras conmemoraciones, aniversaiors y algunas otras fechas relevantes"
    },
    {
        "imagen": "../assets/imgs/inventario_EEGyCEI_Hgo.jpg",
        "url": "/pdf/inventario_ EEGyCEI_Hgo.pdf",
        "titulo": "Inventario Estatal de Emisiones",
        "fecha" : ""
    },
   
    {
        "imagen": "../assets/imgs/EcomapaTecocomulco.jpg",
        "url": "/pdf/EcomapaTecocomulco.pdf",
        "titulo": "Ecomapa Laguna de Tecocomulco",
        "fecha": "Consulta en este mapa algunos de los espacios y sitios de gran relevancia en la zona de Tecocomulco"
    },

   {
        "imagen": "../assets/imgs/ConvocatoriaFOTO.jpg",
        "url": "/pdf/ConvocatoriaFOTO.pdf",
        "titulo": "Exposición fotográfica Foto y Medio Ambiente",
        "fecha": "Participa en la convocatoria y muestra la grandeza del medio ambiente de hidalgo a través de la fotografía"
    },

    {
        "imagen": "../assets/imgs/DATOS EDUCACION AMBIENTAL 2026.jpg",
        "url": "/pdf/DATOS EDUCACION AMBIENTAL 2026.pdf",
        "titulo": "Enero, mes de la educación ambiental.",
        "fecha": "Descubre tips y recomendaciones para fortalecer tu educación ambiental y cuidar nuestro planeta"
    },

     {
        "imagen": "../assets/imgs/ABCIncendios.jpg",
        "url": "/pdf/ABCIncendios.pdf",
        "titulo": "el ABC de los incendios forestales.",
        "fecha": "Conoce todo sobre los incendios forestales. ¿Qué son? ¿Como prevenirlos? y ¿Comó nos afectan?"
    },

    {
        "imagen": "../assets/imgs/TemporadaOzono2026.jpg",
        "url": "/pdf/TemporadaOzono2026.pdf",
        "titulo": "Campaña de Ozono 2026",
        "fecha": "La temporada de ozono ocurre antes de las lluvias, cuando el calor, el cielo despejado y la radiación solar favorecen la formación de este gas en el aire."
    },

    {
        "imagen": "../assets/imgs/ConversacionEcosistemas.jpg",
        "url": "/pdf/ConversacionEcosistemas.pdf",
        "titulo": "Programa de Conservación de Ecosistemas en las Áreas Naturales Protegidas",
        "fecha": "Da clic para conocer la convocatoria para el fortalecimiento de las estrategias de preservación de nuestra biodiversidad"
    },

    {
        "imagen": "../assets/imgs/Croquis-PEC.png",
        "url": "../assets/imgs/Croquis-PEC.jpg",
        "titulo": "Conoce nuestras instalaciones del Parque Ecológico Cubitos",
        "fecha": ""
    },

    {
        "imagen": "../assets/imgs/HIDALGO JUEGA LIMPIO.jpg",
        "url": "/pdf/HIDALGO JUEGA LIMPIO.pdf",
        "titulo": "Hidalgo juega limpio, convocatoria de acopio de prendas de mezclilla y algodón. ",
        "fecha": "Únete al acopio de prendas de algodón y mezclilla en nuestra convocatoria Hidalgo juega limpio del 8 de junio al 8 de agosto."
    },


]